import { useMemo } from "react";

import { useStableRest } from "../../utils/use-stable-rest";
import type {
  EmptyStateRootAttributes,
  EmptyStateViewModel,
  UseEmptyStateOptions,
} from "./types-empty-state";

/** ViewModel do EmptyState: tamanho, ilustração e ids das partes; sem JSX. */
export function useEmptyState({
  size = "md",
  testId,
  className,
  style,
  classNames,
  ...props
}: UseEmptyStateOptions & EmptyStateRootAttributes = {}): EmptyStateViewModel {
  const rest = useStableRest(props);
  return useMemo(
    () => ({
      size,
      illustrationSize: size === "sm" ? "sm" : "lg",
      testId,
      className,
      style,
      classNames: classNames ?? {},
      rest,
      partTestId: (part: string) => (testId ? `${testId}-${part}` : undefined),
    }),
    [size, testId, className, style, classNames, rest],
  );
}
